module.exports = __webpack_public_path__ + "img/14120369000223.182ad089.png";